import { http, hr_http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    contract_type_list,
    contract_legal_audit_users,
    contract_select_search,
    query_stock,
    query_payee_company_account,
    contract_save,
    contract_detail,
    close_contract,
    close_outsource_contract,
    contract_add_e_file_audit,
    contract_check_add_payment,
    es_query_mine_contract,
    contract_noticed_finishing_list,
    placing_ads_record_select_search,
    contract_related_placing_records,
    contract_delete_placing_record,
    contract_save_placing_record,
    outsource_contract_related_placing_records,
    outsource_contract_delete_placing_record,
    outsource_contract_save_placing_record,
    third_part_mall_sub_item,
    ams_platform_list,
    ams_common_login_methods,
    find_customer
 } = util.api || {}

export function getContractTypeListApi(params) {
    return http.get(contract_type_list, params)
}

export function getContractLegalAuditUsersApi(params) {
    return http.get(contract_legal_audit_users, params)
}

export function submitContracSaveApi(params) {
    return http.post(contract_save, params)
}

export function getContractDetailApi(params) {
    return http.get(contract_detail, params)
}
export function closeOutsourceContractApi(params) {
    return http.post(close_outsource_contract, params)
}

export function closeContractApi(params) {
    return http.post(close_contract, params)
}

export function addEFileAuditApi(params) {
    return http.post(contract_add_e_file_audit, params)
}

export function contractCheckAddPaymentApi(params) {
    return http.get(contract_check_add_payment, params)
}

export function getEsQueryMineContractApi(params) {
    return http.get(es_query_mine_contract, params)
}

export function getContractNoticedFinishingListApi(params) {
    return http.get(contract_noticed_finishing_list, params)
}

export function getContractRelatedPlacingRecordsApi(params) {
    return http.get(contract_related_placing_records, params)
}

export function postContractRelatedPlacingRecordDeleteApi(params) {
    return http.post(contract_delete_placing_record, params)
}
// outsource_contract_delete_placing_record
export function postOutsourceContractRelatedPlacingRecordDeleteApi(params) {
    return http.post(outsource_contract_delete_placing_record, params)
}
export function getPlacingAdsRecordSelectSearchApi(params) {
    return http.get(placing_ads_record_select_search, params)
}

export function postContractRelatedPlacingRecordAddApi(params) {
    return http.post(contract_save_placing_record, params)
}
export function postOutsourceContractRelatedPlacingRecordAddApi(params) {
    return http.post(outsource_contract_save_placing_record, params)
}
// outsource_contract_save_placing_record

export function getOurceContractRelatedPlacingRecordsApi(params) {
    return http.get(outsource_contract_related_placing_records, params)
}

// third_part_mall_sub_item
export function getThirdPartMallSubItemApi(params) {
    return http.get(third_part_mall_sub_item, params)
}
// hr_http
export function getAmsPlatformListApi() {
    return hr_http.get(ams_platform_list)
}

export function getAmsCommonLoginMethodsApi() {
    return hr_http.get(ams_common_login_methods)
}

export function getPersonApi(params) {
    return http.get(find_customer, params)
}